
import { useState, Fragment } from "react"
import { Tooltip, IconButton } from "@material-ui/core"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import VisibilityIcon from '@material-ui/icons/Visibility'
import GetAppIcon from '@material-ui/icons/GetApp'
import { makeStyles } from '@material-ui/core/styles'
import { yellow } from "@material-ui/core/colors"
import { useDispatch } from "react-redux"
import { formatDinero } from "./../../../utils/formatDinero"
import { FormatoFechaIso } from "./../../../utils/FormatFecha"
import { DialogMessage } from "../../../global/DialogMessage"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"
import { ToastMessage } from "../../../global/ToastMessage"
import { URL_CONSULTA_COTIZACION } from "../../../Constantes"
import { useSelector } from "react-redux"
import { targetClienteAction, obtenerClientesCotizadorAction, eliminarCotizacionAction, obtenerCotizacionPdf, modalViewCotizadorAction, obtenerCotizacionIdAction, aceptarCotizacionAction } from "../../../ducks/cotizadorDuck";
import BeenhereIcon from '@material-ui/icons/Beenhere'
import ShareIcon from '@material-ui/icons/Share';
import ModalFormAceptarCotizacion from "./ModalFormAceptarCotizacion"
export const TCotizacionesStyle = makeStyles((theme) => ({
    root: {
        width: '100%',
        margin: '1rem 0'
    },
    container: {
        maxHeight: "65vh",
    },
    ButtonContent: {
        display: "flex",
        flexFlow: "column wrap",
        justifyContent: "center",
        alignItems: "center",
    },
    section1: {
        margin: theme.spacing(1, 2),
    },
    section2: {
        margin: theme.spacing(1, 2),
    },
}))
const columns = [
    {
        id: "folioCotizacion",
        minWidth: 50,
        align: "center",
        label: "Folio",
    },
    { id: "paquete", minWidth: 10, align: "center", label: "Paquete" },
    { id: "fecha", minWidth: 50, align: "center", label: "Fecha creacion" },
    { id: "fechaVigencia", minWidth: 50, align: "center", label: "Fecha expiración" },
    { id: "monto", minWidth: 80, align: "center", label: "Monto" },
    { id: "planPagos", minWidth: 80, align: "center", label: "Tipo pago" },
    { id: "estatus", minWidth: 30, align: "center", label: "Estatus" },
    { id: "Accion", minWidth: 10, align: "center", label: "" },
]
const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },

})
function Row(props) {
    const { row, cliente } = props
    const { profile } = useSelector(store => store.logeo)
    const classes = useRowStyles()
    const dispatch = useDispatch()
    const handleShareCotizacion = async ({ id }) => {
        const url = `${URL_CONSULTA_COTIZACION}?id=${id}&profile=${profile.Id}`;
        try {
            await navigator.clipboard.writeText(url)
            ToastMessage.fire({
                icon: "success",
                title: "La cotización se ha copiado al portapapeles. Ahora puedes pegarla donde quieras.",
            })
        } catch (err) {
            ToastMessage.fire({
                icon: "error",
                title: "Hubo un error al copiar la cotización al portapapeles.",
            })
        }
    };
    const handleOpenCotizacion = ({ id }) => {
        window.open(`${URL_CONSULTA_COTIZACION}?id=${id}&profile=${profile.Id}`)
    }
    const handleDowloadCotizacioon = ({ id }) => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerCotizacionPdf({ IdCotizacion: id })).then(Response => {
            dispatch(offLoadAction())
            if (Response?.status === 500) {
                ToastMessage.fire({
                    icon: "warning",
                    title: "Se produjo un error inesperado. Inténtelo de nuevo más tarde",
                });
                return null
            }
            if (Response?.status === 400) {
                ToastMessage.fire({
                    icon: "warning",
                    title: Response.Message,
                });
                return null
            }
            const downloadUrl = window.URL.createObjectURL(new Blob([Response.data], { type: Response.contentType }));
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.target = "_blank"
            link.download = `Cotización-${id}-${new Date().toString()}`;
            document.body.appendChild(link);
            link.click();
            link.remove();
            ToastMessage.fire({
                icon: "success",
                title: "Archivo descargado",
            });
        })
    }
    const onEditar = ({ id }) => {
        dispatch(obtenerCotizacionIdAction({ IdCotizacion: id }))
        dispatch(targetClienteAction({ cliente, vista: 1, editar: false }))
        dispatch(modalViewCotizadorAction({ open: true, update: true, idCotizacion: id }))
    }
    const onAceptarCotizacion = ({ id }) => {
        DialogMessage.fire({
            title: `¿Estas seguro de aceptar la cotizacion con numero: #${id}?`,
            text: "Este cambio no se puede deshacer",
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(onLoadAnction({ message: "Procesando" }))
                dispatch(aceptarCotizacionAction({ IdCotizacion: id })).then((Response) => {
                    dispatch(offLoadAction())
                    if (Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha ocurrido un error, por favor inténtelo de nuevo más tarde",
                        })
                        return null
                    }
                    if (Response.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            title: Response.Message,
                        })
                        return null
                    }
                    dispatch(obtenerClientesCotizadorAction())
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    })
                })
            }
        })
    }
    const onEliminar = ({ id }) => {
        DialogMessage.fire({
            title: '¿Estas seguro de eliminar esta cotizacion?',
            text: "",
            showCancelButton: true,
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(onLoadAnction({ message: "Procesando" }))
                dispatch(eliminarCotizacionAction({ idCotizacion: id })).then((Response) => {
                    dispatch(offLoadAction())
                    if (Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha ocurrido un error, por favor inténtelo de nuevo más tarde",
                        })
                        return null
                    }
                    if (Response.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            title: Response.Message,
                        })
                        return null
                    }
                    dispatch(obtenerClientesCotizadorAction())
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    })
                })
            }
        })
    }
    return (
        <Fragment>
            <TableRow className={classes.root} hover>
                <TableCell align="center">{row.IdCotizacion}</TableCell>
                <TableCell align="center">
                    {row.NombrePaquete}
                </TableCell>
                <TableCell align="center">
                    {FormatoFechaIso({ date: row.FechaRegistro, formato: "dd MMMM yyyy" })}
                </TableCell>
                <TableCell align="center">
                    {FormatoFechaIso({ date: row.FechaExpiracion, formato: "dd MMMM yyyy" })}
                </TableCell>
                <TableCell align="center">
                    {`${formatDinero(row.MontoPaquete)} ${row.Moneda?.Clave}`}
                </TableCell>
                <TableCell align="center">
                    {
                        (row?.lFormatoPago.length > 1) ? "Hibrido" : row?.lFormatoPago[0]?.CatTipoPago?.Nombre

                    }
                </TableCell>
                <TableCell align="center">
                    {row.CatEstatusCotizacion?.Descripcion}
                </TableCell>
                <TableCell>
                    <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                        {
                            (row.CatEstatusCotizacion?.IdCatEstatusCotizacion === 1) &&
                            <Tooltip title="Editar">
                                <IconButton aria-label="delete" onClick={() => onEditar({ id: row.IdCotizacion })}>
                                    <EditIcon style={{ color: yellow[500] }} />
                                </IconButton>
                            </Tooltip>
                        }
                        {
                            (row.CatEstatusCotizacion?.IdCatEstatusCotizacion === 1) &&
                            <Tooltip title="Eliminar">
                                <IconButton aria-label="Eliminar" onClick={() => onEliminar({ id: row.IdCotizacion })}>
                                    <DeleteIcon color="error" />
                                </IconButton>
                            </Tooltip>
                        }
                        <Tooltip title="Compartir">
                            <IconButton aria-label="Compartir" onClick={() => handleShareCotizacion({ id: row.IdCotizacion })}>
                                <ShareIcon color="primary" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Ver">
                            <IconButton aria-label="Ver" onClick={() => handleOpenCotizacion({ id: row.IdCotizacion })}>
                                <VisibilityIcon color="primary" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Descargar">
                            <IconButton aria-label="Descargar" onClick={() => handleDowloadCotizacioon({ id: row.IdCotizacion })}>
                                <GetAppIcon color="secondary" />
                            </IconButton>
                        </Tooltip>
                        {
                            // (row.CatEstatusCotizacion?.IdCatEstatusCotizacion === 1) &&
                            // <Tooltip title="Aceptar cotizacion">
                            //     <IconButton aria-label="aceptarCotizacion" onClick={() => onAceptarCotizacion({ id: row.IdCotizacion })}>
                            //         <BeenhereIcon color="secondary" />
                            //     </IconButton>
                            // </Tooltip>
                        }
                        {
                            (row.CatEstatusCotizacion?.IdCatEstatusCotizacion === 1) &&
                            <ModalFormAceptarCotizacion idCotizacion={row.IdCotizacion} />
                        }
                    </div>
                </TableCell>
            </TableRow>
        </Fragment>
    );
}

export const TCotizaciones = ({ rows, cliente }) => {
    const classes = TCotizacionesStyle();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    }
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    }
    return (
        <Paper className={classes.root}>
            <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth }}
                                >
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row, index) => {
                                return (
                                    <Row
                                        key={row.IdCotizacion}
                                        row={row}
                                        cliente={cliente}
                                    />
                                );
                            })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    );
}
export default TCotizaciones